import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

interface KeyValueModel {
    [key: string]: any
}

type HandlerType = CustomHandler<{attributes: KeyValueModel}>

export const DispatchAttributesParameter: HandlerType = props =>{
    props.dispatch({
        type:"Custom/AHRISystemToolConfigData/attributes",
        attributes: props.parameter.attributes
    })
}
export const chain = [DispatchAttributesParameter];

const AHRISystemToolAhriAttributesHandler = createHandlerChainRunner(chain,"AHRIDataAttributes");
export default AHRISystemToolAhriAttributesHandler;